import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommodityInfo } from '@mommy/models/ec/CommodityInfo.model';

@Component({
  selector: 'app-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
})
export class ProductListItemComponent implements OnInit {
  @Output() commodityOnClick = new EventEmitter<CommodityInfo>();

  _commodity: CommodityInfo;

  constructor() {}

  ngOnInit() {}

  get commodity(): any {
    return this._commodity;
  }

  @Input() set commodity(value: any) {
    console.log('commodity', value);
    if (value) {
      this._commodity = value;
    } else {
      this._commodity = {};
    }
  }

  commodityClick() {
    this.commodityOnClick.emit(this.commodity);
  }
}
